import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('info-icon', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 49 48"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.438 4.5c5.384 0 10.26 2.183 13.788 5.711A19.439 19.439 0 0 1 43.938 24c0 5.385-2.183 10.26-5.712 13.789A19.439 19.439 0 0 1 24.438 43.5a19.439 19.439 0 0 1-13.79-5.711A19.439 19.439 0 0 1 4.939 24c0-5.385 2.182-10.26 5.71-13.789A19.439 19.439 0 0 1 24.439 4.5z",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.54 13l.79 14.608h3.265L27.438 13H22.54zm2.308 17.806c.684 0 1.286.218 1.768.742.442.48.684 1.091.684 1.833 0 .786-.242 1.397-.684 1.877a2.452 2.452 0 0 1-1.768.742c-.683 0-1.245-.262-1.727-.742-.483-.524-.683-1.135-.683-1.877s.2-1.353.683-1.833c.482-.524 1.044-.742 1.727-.742z",
    fill: props.colors[0],
    fillRule: "nonzero"
  })));
});